module.exports = __webpack_public_path__ + "static/media/white-paper.7a316a7a.svg";